import { useEffect, useState } from "react";
import AppShell from "@/components/AppShell";
import api from "@/lib/api";
import { toast } from "sonner";
import { FileText, Upload, Trash2, Eye } from "lucide-react";

const API = process.env.REACT_APP_BACKEND_URL;

export default function AdminSimulasi() {
  const [items, setItems] = useState([]);
  const [title, setTitle] = useState("");
  const [dateLabel, setDateLabel] = useState("");
  const [file, setFile] = useState(null);
  const [busy, setBusy] = useState(false);

  const load = async () => {
    try { const { data } = await api.get("/simulasi"); setItems(data.items || []); }
    catch { toast.error("Gagal memuat daftar"); }
  };
  useEffect(() => { load(); }, []);

  const upload = async () => {
    if (!title.trim()) { toast.error("Isi judul"); return; }
    if (!file) { toast.error("Pilih file PDF"); return; }
    const fd = new FormData();
    fd.append("file", file); fd.append("title", title.trim()); fd.append("date_label", dateLabel.trim());
    setBusy(true);
    try {
      await api.post("/admin/simulasi", fd, { headers: { "Content-Type": "multipart/form-data" } });
      toast.success("Hasil simulasi diunggah");
      setTitle(""); setDateLabel(""); setFile(null);
      const el = document.getElementById("simulasi-file-input"); if (el) el.value = "";
      load();
    } catch (e) { toast.error(e.response?.data?.detail || "Gagal mengunggah"); }
    setBusy(false);
  };
  const remove = async (it) => {
    if (!window.confirm(`Hapus "${it.title}"?`)) return;
    try { await api.delete(`/admin/simulasi/${it.id}`); toast.success("Dihapus"); load(); }
    catch { toast.error("Gagal menghapus"); }
  };

  return (
    <AppShell>
      <div className="max-w-3xl mx-auto" data-testid="admin-simulasi">
        <h1 className="font-heading font-black text-3xl text-[#1A1C1A] mb-1">Hasil Simulasi</h1>
        <p className="text-[#5C5F5C] mb-4">Unggah PDF hasil simulasi. File tampil di halaman publik "Hasil Simulasi" (bisa diakses tanpa login).</p>

        <div className="clay-card p-4 mb-5 space-y-3">
          <input value={title} onChange={(e) => setTitle(e.target.value)} data-testid="simulasi-title-input" placeholder='Judul, mis. "Simulasi 1 - September 2027"'
            className="w-full h-10 px-3 rounded-xl border border-[#E5E0D8] outline-none focus:border-[#E25E3E]" />
          <input value={dateLabel} onChange={(e) => setDateLabel(e.target.value)} data-testid="simulasi-date-input" placeholder="Keterangan tanggal (opsional), mis. September 2027"
            className="w-full h-10 px-3 rounded-xl border border-[#E5E0D8] outline-none focus:border-[#E25E3E]" />
          <input id="simulasi-file-input" type="file" accept="application/pdf" onChange={(e) => setFile(e.target.files?.[0] || null)} data-testid="simulasi-file-input"
            className="block w-full text-sm text-[#5C5F5C] file:mr-3 file:py-2 file:px-4 file:rounded-full file:border-0 file:bg-[#3E6B8A] file:text-white file:cursor-pointer" />
          <button onClick={upload} disabled={busy} data-testid="upload-simulasi-btn"
            className="px-4 py-2 rounded-full bg-[#1A1C1A] text-white text-sm font-medium inline-flex items-center gap-1.5 disabled:opacity-50"><Upload className="h-4 w-4" /> {busy ? "Mengunggah…" : "Unggah PDF"}</button>
        </div>

        <div className="clay-card divide-y divide-[#F0ECE4]">
          {items.length === 0 && <div className="p-5 text-sm text-[#9C9A94]">Belum ada file.</div>}
          {items.map((it) => (
            <div key={it.id} className="flex items-center gap-3 p-4" data-testid={`simulasi-row-${it.id}`}>
              <div className="h-10 w-10 rounded-xl bg-[#E25E3E]/10 flex items-center justify-center shrink-0"><FileText className="h-5 w-5 text-[#E25E3E]" /></div>
              <div className="flex-1 min-w-0">
                <div className="font-medium text-[#1A1C1A] truncate">{it.title}</div>
                <div className="text-xs text-[#9C9A94]">{it.date_label || "—"} · {(it.size / 1024 / 1024).toFixed(2)} MB</div>
              </div>
              <a href={`${API}/api/simulasi/${it.id}/file`} target="_blank" rel="noreferrer" data-testid={`preview-simulasi-${it.id}`} className="p-2 rounded-lg text-[#3E6B8A] hover:bg-[#3E6B8A]/10"><Eye className="h-4 w-4" /></a>
              <button onClick={() => remove(it)} data-testid={`delete-simulasi-${it.id}`} className="p-2 rounded-lg text-[#D9381E] hover:bg-[#D9381E]/10"><Trash2 className="h-4 w-4" /></button>
            </div>
          ))}
        </div>
      </div>
    </AppShell>
  );
}
